@use "../../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../../styles/layout";

.container {
    align-items: center;
    display: flex;
    gap: 1rem;
    padding: 16px;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        flex-direction: column;
    }
}

.cta {
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
    white-space: nowrap;
}

.form {
    flex-grow: 1;
    position: relative;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        width: 100%;
    }
}

.label {
    & svg {
        height: 26px;
        left: 0;
        position: absolute;
        top: 0;
        transform: translate(40%, 40%);
        width: 26px;
    }
}

.searchInput {
    border-radius: 5px;
    border: 1px solid var(--color-kingly-cloud);
    box-shadow: inset 0 1px 2px var(--color-kingly-cloud);
    color: var(--color-black);
    display: block;
    height: 50px;
    font-family: inherit;
    font-size: 1rem;
    margin: 0;
    padding: 0.5rem;
    text-indent: 40px;
    width: 100%;

    &:focus {
        box-shadow: 0 0 5px var(--color-kingly-cloud);
        outline: none;
    }
}

.submit {
    background: var(--color-crimson);
    border-radius: 50%;
    height: 30px;
    width: 30px;
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(-35%, 35%);

    svg {
        height: 16px;
        fill: var(--color-white);
        transform: translateY(2px);
    }
}

.otherActions {
    a,
    button {
        display: block;
    }
}

.currentLocationButton {
    color: var(--color-crimson);
    text-decoration: underline;
}
